// BuilderTutorialOverlay - ビルダー編集画面の初回ガイド（spec.md §5.8.6）
// 表示は共通の GuideOverlay。ここでは案内対象・文言と、進捗の保存だけを持つ。

import { useSelector } from "react-redux";
import { RootState } from "app/store";
import { saveTutorialProgress } from "features/builder/api";
import { GuideStep, GuideOverlay } from "features/builder/elements/GuideOverlay";

export const TUTORIAL_DONE_KEY = "piece_builder_tutorial_done";

// ガイドが指す要素の id。対象側の JSX にこの id を付ける
export const BuilderGuideTargetId = {
  ASSET_CHARACTER: "builder-guide-asset-character",
  ASSET_GOAL: "builder-guide-asset-goal",
  ASSET_SLOTS: "builder-guide-asset-slots",
  TEST_BTN: "builder-guide-test",
  // 「かんせいの じゅんび」の見出し（進み具合）。パネル全体だと無効のボタンまで照らしてしまう
  PUBLISH_PROGRESS: "builder-guide-publish-progress",
} as const;

const STEPS: GuideStep[] = [
  {
    targetId: BuilderGuideTargetId.ASSET_CHARACTER,
    titleKey: "MSG_BUILDER_TUTORIAL_STEP1_TITLE",
    descKey: "MSG_BUILDER_TUTORIAL_STEP1_DESC",
  },
  {
    targetId: BuilderGuideTargetId.ASSET_GOAL,
    titleKey: "MSG_BUILDER_TUTORIAL_STEP2_TITLE",
    descKey: "MSG_BUILDER_TUTORIAL_STEP2_DESC",
  },
  {
    targetId: BuilderGuideTargetId.ASSET_SLOTS,
    titleKey: "MSG_BUILDER_TUTORIAL_STEP3_TITLE",
    descKey: "MSG_BUILDER_TUTORIAL_STEP3_DESC",
  },
  {
    targetId: BuilderGuideTargetId.TEST_BTN,
    titleKey: "MSG_BUILDER_TUTORIAL_STEP4_TITLE",
    descKey: "MSG_BUILDER_TUTORIAL_STEP4_DESC",
  },
  {
    targetId: BuilderGuideTargetId.PUBLISH_PROGRESS,
    titleKey: "MSG_BUILDER_TUTORIAL_STEP5_TITLE",
    descKey: "MSG_BUILDER_TUTORIAL_STEP5_DESC",
  },
];

export const BuilderTutorialOverlay = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const active = useSelector((state: RootState) => state.user.active);

  const handleClose = () => {
    window.localStorage.setItem(TUTORIAL_DONE_KEY, "1");
    saveTutorialProgress({ uid: active.uid, step_id: STEPS.length });
    onClose();
  };

  return <GuideOverlay open={open} steps={STEPS} onClose={handleClose} />;
};
